module.exports = __webpack_public_path__ + "static/media/caveRock.9015dcd6.png";